import { render, staticRenderFns } from "./ConfirmWaitingAbsenceWidget.vue?vue&type=template&id=6ef2a88f&"
import script from "./ConfirmWaitingAbsenceWidget.vue?vue&type=script&lang=js&"
export * from "./ConfirmWaitingAbsenceWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports